<template>
	<div class="bulk">
		<div class="bulk__checkbox">
			<Checkbox :displayLabel="false" />
		</div>
		<div class="bulk__dropdown">
			<Dropdown
				ref="bulkDropdown"
				:options="source"
				:displayError="false"
				:displayHelp="false"
				v-model="dataValue"
			/>
		</div>
	</div>
</template>

<script>
import Checkbox from '@/components/forms/selection-control/checkbox/checkbox';
import Dropdown from '@/components/forms/dropdown/dropdown.vue';

export default {
	name: 'Bulk',
	components: {
		Checkbox,
		Dropdown
	},
	model: {
		prop: 'dropdownValue',
		event: 'change'
	},
	props: {
		source: {
			type: Array,
			default: () => ['Bulk/Actions', 'Turn on', 'Turn off']
		},
		dropdownValue: {
			type: [String]
		}
	},
	data() {
		return {
			dataValue: ''
		};
	},
	watch: {
		dropdownValue: {
			immediate: true,
			handler(val) {
				this.dataValue = val;
			}
		},
		dataValue: {
			handler(val) {
				if (val !== this.dropdownValue) {
					this.$emit('change', val);
				}
			}
		}
	}
};
</script>

<style lang="scss">
.bulk {
	display: inline-flex;
	background: $white;

	.bulk__checkbox {
		display: flex;
		min-width: 32px;
		align-items: center;
		justify-content: center;
		border: 1px solid $neutral-3;
		border-right: 0;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
	}

	.bulk__dropdown {
		min-width: 120px;
		.dropdown {
			.dropdown__input-container,
			.dropdown__input-container:focus {
				border-top-left-radius: 0;
				border-bottom-left-radius: 0;
			}

			.dropdown__selected {
				border-top-left-radius: 0px;
				border-bottom-left-radius: 0px;
			}
		}
	}
}
</style>
